import React from "react";

const ActiveGameWrapper = ({ children }) => {
  return (
    <>
      {children}
      <img src="/static/images/board.png" className="board" alt="banner" />
    </>
  );
};

export default ActiveGameWrapper;
